import { Redirect, Stack } from 'expo-router';
import DesktopNavigation from 'shared/components/vxl/navigation/DesktopNavigation/DesktopNavigation';
import useIsFeatureEnabled from 'shared/hooks/statsig/useIsFeatureEnabled/useIsFeatureEnabled';
import { useShouldShowDesktopNavigation } from 'shared/hooks/useShouldShowDesktopNavigation';
import { FeatureFlagKey } from 'shared/providers/statsig/StatsigProvider.d';

function PayLaterWebLayout() {
  const isPayLaterEnabled = useIsFeatureEnabled(
    FeatureFlagKey.ENABLE_PAY_LATER,
  );
  const shouldShowDesktopNavigation = useShouldShowDesktopNavigation();

  if (!isPayLaterEnabled) {
    return <Redirect href="/" />;
  }

  return shouldShowDesktopNavigation ? (
    <DesktopNavigation>
      <Stack />
    </DesktopNavigation>
  ) : (
    <Stack />
  );
}

export default PayLaterWebLayout;
